import {createSelector} from 'reselect';
import {cxpSession} from './cxpSession';
import {presetCxpSessionId} from './presetCxpSessionId';

export const cxpSessionId = createSelector(
  cxpSession,
  presetCxpSessionId,
  (cxpSession, presetCxpSessionId) => presetCxpSessionId || cxpSession?.sessionId || ''
);
